import React, { useRef } from 'react';

type TouchSwipeWrapperProps = {
    children: React.ReactNode;
    touchToLeft?: () => void;
    touchToRight?: () => void;
    threshold?: number; // Optional: minimum distance in px to consider a swipe
};

export const TouchSwipeWrapper: React.FC<TouchSwipeWrapperProps> = ({
    children,
    touchToLeft,
    touchToRight,
    threshold = 60,
}) => {
    const touchStartX = useRef<number | null>(null);

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e: React.TouchEvent) => {
        if (touchStartX.current === null) return;

        const touchEndX = e.changedTouches[0].clientX;
        const deltaX = touchEndX - touchStartX.current;
        if (Math.abs(deltaX) >= threshold) {
            if (deltaX > 0) {
                if (touchToRight) {
                    touchToRight(); // Swiped right
                }
            } else if (touchToLeft) {
                touchToLeft(); // Swiped left
            }
        }

        touchStartX.current = null;
    };

    return (
        <div
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            style={{ touchAction: 'pan-y' }} // allows vertical scrolling while detecting horizontal swipes
        >
            {children}
        </div>
    );
};
